import React from 'react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 bg-sage-dark text-white relative overflow-hidden" data-id="element-20">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-21">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-22"></div>
        <div className="absolute bottom-0 right-0 w-full max-w-2xl h-96 rounded-full bg-sage-light blur-3xl" data-id="element-23"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-24">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-25">
          Ready to feel lighter, calmer, and more comfortable in your body?
        </h2>

        <p className="text-xl md:text-2xl text-sage-light mb-10 font-serif italic" data-id="element-26">
          Your belly will thank you in 14 days or less.
        </p>

        <div className="flex flex-col items-center justify-center space-y-8" data-id="element-27">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center max-w-sm w-full border border-white/20" data-id="element-28">
            <span className="inline-block bg-white/20 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3" data-id="element-29">
              Limited-Time Offer
            </span>
            <div className="flex items-center justify-center gap-3 mb-1" data-id="element-30">
              <span className="text-xl text-white/50 line-through" data-id="element-31">$27</span>
              <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-32">
                <span className="text-2xl align-top" data-id="element-33">$</span>9
                <span className="text-3xl" data-id="element-34">.38</span>
              </span>
            </div>
            <p className="text-sm text-sage-light font-medium mb-5" data-id="element-35">
              You save over 65%
            </p>
            <a href="https://wellnessresetzone.com/cart/47635769327668:1" target="_blank" rel="noopener noreferrer" className="inline-flex w-full justify-center items-center px-10 py-5 text-xl font-bold rounded-full text-sage-dark bg-white hover:bg-cream-light shadow-2xl transition-all hover:-translate-y-1" data-id="element-36">
              Get Your 14-Day Belly Reset
            </a>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/m4nt6t4k6zVd5tp5B79GQr/14_day_dbloat.png" alt="14-Day Belly Reset Plan eBook" className="w-full max-w-xs md:max-w-sm h-auto rounded-xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500 border-4 border-white/10" data-id="element-37" />
        </div>
      </div>
    </section>;
}